import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";
import RequisitionForm from "../Requisition/RequisitionNumberModal";

import Swal from 'sweetalert2';


const Fab = ({ onSuccess }) => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [requisition, setRequisiton] = useState('');
  const [selectedRequisition, setSelectedRequisiton] = useState('');

  const [mrv,setMrv]=useState([])
  const [selectedMrv, setSelectedMrv] = useState([])
  const [run, setRun] = useState(0);
 const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([
    { name: "", inventoryId: "",description:"", approveQty: 0, qtyRequired: 0 ,quantity: 0,damageQty:0,error:"" },
  ]);
  const [partOptions, setPartOptions] = useState([]);
  const [item, setItem] = useState();

  const handleAddItem = (e) => {
    e.preventDefault();
    const lastItem = items[items.length - 1];
    
    // Check for required fields
    if (!lastItem || !lastItem.inventoryId || !lastItem.name || lastItem.quantity <= 0) {
        Swal.fire({
            icon: 'warning',
            title: 'Incomplete Item',
            text: 'Please fill in all fields (Inventory, Name, and Required Qty) before adding a new item.',
            confirmButtonText: 'OK'
        });
        return; // Exit if the last item doesn't have all required fields filled
    }
    setItems([
      ...items,
      { name: "", inventoryId: "",description:"", approveQty: 0, qtyRequired: 0 ,quantity: 0,damageQty:0,error:"" },
    ]);
  };

  const handleItemChange = (index, field, value) => {
    // Convert value to number if it's for quantity or damageQty
    const numericValue = (field === "quantity" || field === "damageQty") ? parseFloat(value) : value;

    const newItems = [...items];
    newItems[index][field] = numericValue;

    if (field === "quantity") {
         if (numericValue < 0) {
            newItems[index].error = `Recived Qty cannot be 0 or negative`;
        } else {
            newItems[index].error = "";
        }
    }

    if (field === "damageQty") {
        if (numericValue < 0) {
            newItems[index].error = `Damage Qty cannot be 0 or negative`;
        } else {
            newItems[index].error = "";
        }
    }
    
    setItems(newItems);
};

  const handlePartSelect = (index, selectedOption) => {
    const isDuplicate = items.some(item => item.inventoryId === selectedOption.value);

    if (isDuplicate) {
        Swal.fire({
            icon: 'error',
            title: 'Duplicate Item',
            text: 'This item has already been added to the requisition.',
            confirmButtonText: 'OK'
        });
        return; // Exit the function if a duplicate is found
    }
    
    handleItemChange(index, "inventoryId", selectedOption.value);
    handleItemChange(index, "name", selectedOption.label);
    handleItemChange(index, "approveQty", selectedOption.approveQty);
    handleItemChange(index, "qtyRequired", selectedOption.qtyRequired);
    handleItemChange(index, "description", selectedOption.description); // Set description
   
  };
  
  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };
  useEffect(() => {
    if (selectedStore) {
      setItems([
        { name: "", inventoryId: "",description:"", approveQty: 0, qtyRequired: 0 ,quantity: 0,damageQty:0,error:"" },
      ])
      RequestServies.getFabrication(selectedStore,"initiated")
        .then((res) => {
          console.log(res)
          setMrv(res?.fabrications);
          setSelectedMrv(res?.fabrications[0]?._id)
          // setRequisiton(res?.data?.data);
          // setSelectedRequisiton(res?.data?.data[0]._id);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [selectedStore, run]);

  useEffect(() => {
    const fetchInventory = async () => {
        setLoading(true); // Set loading to true before fetching
        setPartOptions({})
        try {
            const res = await ProductServices.getInventory(selectedStore);
            const options = res.data.data.map((part) => ({
                value: part._id,
                label: part.masterItem.partNo,
                auth: part.qtyAuth,
                description: part.masterItem.description,
                currentStock: part.currentStock,
            }));
            setPartOptions(options);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false); // Set loading to false after fetching
        }
    };

    if (selectedStore) {
        fetchInventory();
        setItems([
          { name: "", inventoryId: "",description:"", currentQty: 0, auth: 0, quantity: 0, error: "" },
        ])
    }
}, [selectedStore]);

  const handleSubmit = (e) => {

    e.preventDefault();

    let isValid = true;
    let errorMessage = "";

    items.forEach((item, index) => {
      if (item.quantity < 0) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be 0 or negative`;
      }else if(item.damageQty< 0){
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be 0 or negative`;
     
      }else if(!selectedMrv){
        isValid = false;
        errorMessage = `Fabrication Numner Not Selected !`;
     
      }
    });

    if (!isValid) {
      //alert(errorMessage);
      Swal.fire({
        title: 'Error!',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }


    const requestData = { fabricationId: selectedMrv, receivedItem:items };

    RequestServies.submitCompleteFabrication(requestData)
      .then((response) => {
        Swal.fire({
          title: 'Success!',
          text: 'Order has been Recievd Successful',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        setItems([
          { name: "", inventoryId: "",description:"", approveQty: 0, qtyRequired: 0 ,quantity: 0,damageQty:0,error:"" },
        ])
        setRun(run + 1)

      })
      .catch((error) => {
        console.log('Error during submission:', error);
        Swal.fire({
          title: 'Error!',
          text: 'Error during submission',
          icon: 'error',
          confirmButtonText: 'Retry',
        });
      });

  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedMrv();
  };

  const handleRequsitionChange = (e) => {
    setSelectedRequisiton(e.target.value);
  };
  const handleRequisitionForm = (item) => {
    setIsModelOpen(true);
  };

  const handleMrv = (e) =>{
    setSelectedMrv(e.target.value)
  }
  return (
    <>
    
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-6 col-xxl-6">
                      <label>Select Store</label>
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {store.name}
                          </option>
                        ))}
                      </select>
                    </div>
                                        
                    <div className="col-xl-6 col-xxl-6">
                      <label>Select Fabiraction No.</label>
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedMrv}
                        onChange={handleMrv}
                      >
                        {mrv.length > 0 ? (
                          mrv.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.fabricationNo}
                            </option>
                          ))
                        ) : (
                          <option disabled>No records found</option> // Disable the no records option
                        )}
                      </select>
                    </div>
                  

                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Select
                Fabrication Received Item
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <form>
                        {items.map((item, index) => (
                          <div key={index} className="row">
                            <div className="form-group mb-2 col-md-2">
                              <label>Part Number</label>
                              <Select
                                options={partOptions}
                                onChange={(selectedOption) =>
                                  handlePartSelect(index, selectedOption)
                                }
                                placeholder="Part"
                                menuPortalTarget={document.body}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minWidth:90, // increase width (adjust as needed)
                                    height:14, // increase height (adjust as needed)
                                    fontSize: '12px', // change font size (optional)
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    height: '100%', // ensures the value container aligns with the control height
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    height: 'auto', // allows the input to grow with the control's height
                                  }),
                                }}
                              />
                            </div>
                            
                            <div className="form-group mb-2 col-md-5">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="description"
                                value={item.description}
                                placeholder="Description"
                              />
                            </div>
                                                        
                            <div className="form-group mb-2 col-md-2">
                              <label>Received Qty</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="quantity"
                                value={item.quantity}
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "quantity",
                                    event.target.value
                                  )
                                }
                                placeholder="quantity"
                              />
                              <p className="text-danger">{item.error}</p>
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Damage</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="damageQty"
                                value={item.damageQty}
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "damageQty",
                                    event.target.value
                                  )
                                }
                                placeholder="Damage Qty"
                              />
                              <p className="text-danger">{item.error}</p>
                            </div>
                            <div className="form-group mb-1 col-md-1">
                             
                              <button className="btn btn-danger btn-xs sharp mt-1"
                                onClick={(e) => handleRemoveItem(e, index)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                        <div className="row">
                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={(e) => handleAddItem(e)}
                            >
                              Add Item
                            </button>
                          </div>

                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default Fab;
